import { useState } from "react";
import { useLocSettings } from "../hooks/SettingsHooks";
import { Button, Modal, ModalBody } from "reactstrap";
import PropTypes from "prop-types";
import { modalZIndex } from "../utils/UiUtils";
import { useSpecsTranslation } from "../hooks/TranslationHooks";
import Icon from "./Icon";

const InfoIconWithPopup = ({ field }) => {
  const settings = useLocSettings();
  const ts = useSpecsTranslation();

  const legend = settings.specifications?.[field]?.description;

  const [show, setShow] = useState(false);
  const toggle = () => setShow(!show);

  if (legend) {
    return (
      <>
        <span onClick={toggle} className="icon" style={{ cursor: "pointer" }}>
          <Icon name="circle-info" type="fas" />
        </span>
        <Modal isOpen={show} toggle={toggle} size={"lg"} zIndex={modalZIndex()}>
          <ModalBody>
            <Button close={true} onClick={toggle}>
              <Icon name="xmark" type="fal" />
            </Button>
            <h4>{ts(field)}</h4>
            <div dangerouslySetInnerHTML={{ __html: legend }} />
          </ModalBody>
        </Modal>
      </>
    );
  }
  return null;
};

InfoIconWithPopup.propTypes = {
  field: PropTypes.string.isRequired
};

export default InfoIconWithPopup;
